module.exports = __webpack_public_path__ + "img/news2-3.5c93c48e.png";